import first from 'lodash/first';
import moment from 'moment';
import { createSelector } from 'reselect';

import {
    getMyTherapists,
    getOutOfTheAppTherapists,
} from 'src/modules/providers/selectors/providersSelectors';
import { getFeatureFlags } from 'src/modules/user/selectors/featureFlags';
import { getUserInformation } from 'src/modules/user/selectors/userSelectors';
import { getTherapySessions } from 'src/modules/videoSessions/selectors/videoSessionsSelectors';

export const shouldShowReTriageFlow = createSelector(
    getFeatureFlags,
    getMyTherapists,
    getOutOfTheAppTherapists,
    getTherapySessions,
    getUserInformation,
    (featureFlags, outOfTheAppTherapists, myTherapists, sessions, { careRecommendations }) => {
        // user needs to be matched with at least one therapist (in-app or out-of-the-app)
        if (
            (myTherapists.length < 1 && outOfTheAppTherapists.length < 1) ||
            featureFlags.hideReTriageFlow
        ) {
            return false;
        }

        // we save the information that user has already completed re-triage flow
        // in a careRecommendation record marked as non-onboarding (onboarding=false)
        const nonOnboardingCareRecommendations = careRecommendations.filter(
            ({ onboarding }) => onboarding !== true,
        );

        if (nonOnboardingCareRecommendations?.length) {
            // getting the latest non-onboarding careRecommendation record
            const mostRecentCareRecommendation = first(
                nonOnboardingCareRecommendations.sort((a, b) => {
                    return +new Date(b.startedAt) - +new Date(a.startedAt);
                }),
            );

            const daysDifference = moment(moment()).diff(
                moment(mostRecentCareRecommendation?.startedAt),
                'days',
            );

            // user should not see re-triage flow again if it was completed less than 90 days ago
            if (daysDifference < 90) {
                return false;
            }
        }

        // getting the latest therapy session (completed or scheduled)
        const mostRecentSession = first(
            sessions.sort((a, b) => {
                return +new Date(b.scheduledTime) - +new Date(a.scheduledTime);
            }),
        );

        const daysElapsed = moment(moment()).diff(moment(mostRecentSession?.scheduledTime), 'days');

        // user should see re-triage flow only if the latest therapy session took place at least 90 days ago
        return daysElapsed >= 90;
    },
);
